export default "__VITE_ASSET__CVZlMCN4__"